import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  position: relative;
`

export const Filter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  padding: 3rem 0;

  .select-stylized {
    width: 100%;
    max-width: 14rem;

    @media screen and (max-width: 576px) {
      max-width: none;
    }
  }
`

export const Label = styled.span`
  margin-right: 1rem;
`
